import axios from 'axios';

import { endsWith } from '../../../polyfill/index';
import Page from './page';
import Component from './component';
import SEO from './seo';
import { useRelativeLink } from '../util';

// ISNODE is boolean false in production frontend, which makes all URLs relative; boolean true during SSR;
// when it's true, all API URLs get prefixed with production domain to make sure HPServices data is retrievable;
// thanks to endsWith(..., "hp.com") checks, URLs stay prefixed even on local environments when ISNODE might be
// accidentally missing and document.location.hostname resolves to "localhost"
const basename = process.env.BASENAME;

const _EtrAPI = function () {
    let self = this;
    let config = {
        siteInfo: {
            langId: -1,
            storeId: 10151,
            catalogId: 10051,
        },
    };
    let etrWCSInstance = axios.create({
        baseURL: useRelativeLink() ? '/wcs/resources/store/' : 'https://uat3live.store.hp.com/wcs/resources/store/',
    });

    //debug
    etrWCSInstance.interceptors.request.use((httpConfig) => {
        console.log(httpConfig);
        return httpConfig;
    });

    self.page = new Page(config, etrWCSInstance);
    self.component = new Component(config, etrWCSInstance);
    self.seo = new SEO(config, etrWCSInstance);
    self.httpInstance = etrWCSInstance;
};

const EtrAPI = new _EtrAPI();

export default EtrAPI;